import React, { useState } from "react";
import { T } from "../theme";
import TimelineChart, { chartRange, monthIndex } from "../components/TimelineChart";
import { CLIENT_PHASES } from "./now";

// The client roadmap over time: one row per stored phase (Activation,
// In Flight), a dot per dated step. Opens three months back so the horizon
// is the point; "earlier" widens it to the first dated step. Undated steps
// are not drawn; they stay in the list below. Wraps the shared TimelineChart.
export const phaseRows = (steps, phases = CLIENT_PHASES) => phases.map(phase => ({ key: phase, label: phase, dots: (steps?.[phase] || []).filter(r => r.date) }));
const ym = i => `${Math.floor(i / 12)}-${String(i % 12 + 1).padStart(2, "0")}`;

export function timelineRange(steps, today) {
  return chartRange(phaseRows(steps), today);
}

export default function Timeline({ steps, today, phases }) {
  const [earlier, setEarlier] = useState(false);
  const rows = phaseRows(steps, phases);
  const full = chartRange(rows, today);
  if (!full) return null;
  const start = Math.max(full.from, monthIndex(today) - 3);
  const end = Math.min(full.to - 1, monthIndex(today) + 24); // two years ahead is plenty for a client page
  const hidden = rows.reduce((n, r) => n + r.dots.filter(d => monthIndex(d.date) < start).length, 0);
  const link = { background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: T.fontSans, fontSize: 12, fontWeight: 600, color: T.pine };
  return (
    <div>
      {hidden > 0 && <div style={{ fontSize: 12, color: T.fgMuted, marginTop: 4 }}>
        {earlier ? <button onClick={() => setEarlier(false)} style={link}>◂ from {ym(start).slice(0, 4)}</button> : <button onClick={() => setEarlier(true)} style={link}>◂ earlier · {hidden} step{hidden === 1 ? "" : "s"} done</button>}
      </div>}
      <TimelineChart rows={rows} today={today} labelWidth={rows.some(r => r.label.length > 10) ? 124 : 92} from={earlier ? undefined : ym(start)} to={ym(end)} shadeMonth={today.slice(0, 7)} />
    </div>
  );
}
